module.exports = __webpack_public_path__ + "static/media/sack.5d8849e6.svg";